var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeasonTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.45 38.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.25,1h13c7.95,0,12.05,3.2,12.05,9.3,0,4.25-2.1,6.8-4.95,7.75,4.4,1.05,6.6,4.5,6.6,9.05,0,7.5-4.85,10.4-12,10.4H.25c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25ZM12.25,16.85c6.4,0,9.15-1.95,9.15-6.55s-3.15-5.95-9.9-5.95H3.9v12.5h8.35ZM12.3,34.1c7.2,0,10.75-.85,10.75-7,0-5.7-3.9-6.8-10.35-6.8H3.9v13.8h8.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.1,1h3.4c.15,0,.25.1.25.25v36c0,.15-.1.25-.25.25h-3.4c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80.95,1.25v36c0,.15-.1.25-.25.25h-3.9c-.15,0-.25-.05-.3-.15L56.2,6.45v30.8c0,.15-.1.25-.25.25h-3.4c-.15,0-.25-.1-.25-.25V1.25c0-.15.1-.25.25-.25h3.8c.15,0,.25.05.3.15l20.4,30.9V1.25c0-.15.1-.25.25-.25h3.4c.15,0,.25.1.25.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119.05,11.7c-1.15-5.2-5.8-8.3-11.05-8.3-9.65,0-13.25,7.2-13.25,17,0,8,4.8,14.65,12.8,14.65,7.85-.05,12.2-5.65,12.15-13.25h-11.9c-.15,0-.25-.1-.25-.25v-2.9c0-.15.1-.25.25-.25h15.45c.15,0,.25.1.25.25v18.6c0,.15-.1.25-.25.25h-2.95c-.15,0-.25-.1-.25-.25v-5.25c-2.7,4.2-6.75,6.45-13.2,6.45-10.7,0-16-8.3-16-19.4S96.65,0,107.75,0c4.45,0,8.3,1.3,11.05,3.8,2.05,1.85,3.65,4.45,4.25,7.85.05.15-.05.25-.2.25h-3.5c-.15,0-.25-.05-.3-.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M149.4,38.45c-10.9,0-17-8.3-17-19.15S138.45,0,149.25,0s17.2,8.3,17.2,19.3-6.05,19.15-17.05,19.15ZM149.45,35.05c8.8,0,13.1-6.85,13.1-15.75s-4.4-15.9-13.2-15.9-13.05,7.05-13.05,15.9,4.1,15.75,13.15,15.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonTitle);
export default __webpack_public_path__ + "static/media/season_title.b5af4f275c17dbf12d16635e3395fcdd.svg";
export { ForwardRef as ReactComponent };